"use client";

import { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import styles from "./download.module.css";

const DEFAULT_URL = "https://pharmapp.blprog.com/download";

export function DownloadCard() {
  const [qrValue, setQrValue] = useState(DEFAULT_URL);

  useEffect(() => {
    setQrValue(window.location.href)
  }, [])

  

  return (
    <div className={styles.qrCard}>
      <div className={styles.qrFrame}>
        <QRCode value={qrValue} size={260} bgColor="transparent" fgColor="#12573b" />
      </div>
      <p className={styles.qrHint}>
        Scannez ce QR code avec votre téléphone pour ouvrir directement la page de téléchargement de Pharmapp.
      </p>
    </div>
  );
}
